import Picker from 'react-giphy-component'
import ReactDOM from 'react-dom'
import React, { Component, PropTypes } from 'react'
 
class TestComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
          
         
        };
        this.open = this.open.bind(this);
    }
  log (gif) {
      let gifimage = gif.downsized.url.split('/');
      let gifconcat = `${gifimage[0]}/${gifimage[1]}/${gifimage[2]}/${gifimage[3]}/${gifimage[4]}/200w_d.gif`;
      this.props.selectGif(gif.downsized.url);
  }
  open(){
    this.props.opengiffy();
  }
  render () {
    return (
      <div id="giffy_chat">
        <a onClick={this.open} >	
          <i className="fa fa-times"></i>
        </a>
        <Picker onSelected={this.log.bind(this)} />
      </div>
    )
  }
}
export default (TestComponent);